//Editor HTML
import { NgxEditorModule } from 'ngx-editor';

//Crear PDF
// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
// import { reducer } from '../redux/app.reducers';
import { MyMonitoringService } from '@services/microsoft/applicationInsights.services';
import { RollbarErrorHandlerService } from '@services/error/rollbarErrorHandler.service';

import { AppRoutingModule } from '../app-routing.module';
import { AuthGuardService } from '@guards/auth-guard/auth-guard.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA, DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from '../app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule, registerLocaleData } from '@angular/common';

// importar locales
import localePy from '@angular/common/locales/es-PY';
import localePt from '@angular/common/locales/pt';
import localeEn from '@angular/common/locales/en';
import localeEsAr from '@angular/common/locales/es-AR';

//App

import { provideEnvironmentNgxMask } from 'ngx-mask';
import { SharedModule } from './shared.module';
import { CanDeactivateGuard } from '../directives/can-deactivate/can-deactivate.guard';
import { GlobalHttpErrorInterceptorService } from '../interceptors/error-interceptor/error-interceptor.service';
import { LayoutModule } from '@angular/cdk/layout';

// registrar los locales con el nombre que quieras utilizar a la hora de proveer
registerLocaleData(localePy, 'es');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeEsAr, 'es-Ar');

//ngx-markdown
// import 'prismjs';
// import 'prismjs/components/prism-typescript.min.js';
// import 'prismjs/plugins/line-numbers/prism-line-numbers.js';
// import 'prismjs/plugins/line-highlight/prism-line-highlight.js';

//Breadcrum
// import { NgDynamicBreadcrumbModule } from "ng-dynamic-breadcrumb";

//Manejo de Errores
import { AuthInterceptorService } from 'src/app/interceptors/auth/auth-interceptor.service';

//Graficos
import { Chart } from 'chart.js';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ComponentModule } from './component.module';
import { TINYMCE_SCRIPT_SRC, EditorModule } from '@tinymce/tinymce-angular';
import { BrowserModule } from '@angular/platform-browser';
import { httpClientInterceptor } from '../interceptors/http-client-interceptor/http-client.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';


// Microsfot Application Insights
// @Injectable()
// export class ErrorHandlerService extends ErrorHandler {

//   constructor(@Inject(MyMonitoringService) private myMonitoringService: MyMonitoringService) {
//     super();
//   }
//   handleErrorInsights(error: Error) {
//     this.myMonitoringService.logException(error); // Manually log exception
//   }
// }

@NgModule({ declarations: [
        AppComponent,
    ],
    exports: [],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        SharedModule,
        LayoutModule,
        ComponentModule,
        CommonModule,
        //BreadcrumbModule https://udayvunnam.github.io/xng-breadcrumb/#/quickstart
        // BreadcrumbModule,
        //NGX Mask https://www.npmjs.com/package/ngx-mask
        // NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
        //Breadcrum
        //NgDynamicBreadcrumbModule,
        //Spinner https://www.npmjs.com/package/ngx-spinner
        BrowserAnimationsModule,
        NoopAnimationsModule,
        NgxSpinnerModule,
        //
        AppRoutingModule,
        ReactiveFormsModule,
        //Editor HTML
        NgxEditorModule,
        EditorModule,
        FullCalendarModule], providers: [
        provideEnvironmentNgxMask(),
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
        AuthGuardService,
        CanDeactivateGuard,
        AuthInterceptorService,
        MyMonitoringService,
        //locales
        { provide: LOCALE_ID, useValue: 'es-Ar' },
        { provide: DEFAULT_CURRENCY_CODE, useValue: '$' },
        { provide: ErrorHandler, useClass: RollbarErrorHandlerService },
        //Error Service
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GlobalHttpErrorInterceptorService,
            multi: true,
        },
        //Autenticacion
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: httpClientInterceptor,
            multi: true,
        },

        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {

}
